export default __webpack_public_path__ + "static/media/semai-logo.bd6d47c2.png";